import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"

const TempComp = () => {


    return ( 
        <>

                                    {/*navigate section*/}

      <div className="main_cont fixed-top">
          <nav className=" pe-3 mobile_cont d-none nav_cont">
            <ul>
                <a href="/"><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"15%"}}/></a> 
              <div className="d-inline pt-4" style={{"float":"right","letterSpacing":"4px"}}>
              <Link to={"/signup"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center activ_box" > <p className="activ">Free Offer</p></div></Link>
              <Link to={"/"}  className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Home</div></Link>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Websites</div></Link>
              <Link to={"/about"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >About</div></Link>
              <Link to={"/policy"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Policy</div></Link>
              <a href="/" className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Contact</div></a>
              </div>
            </ul>
          </nav>
        

<nav className="mobile_cont d-md-none fixed-top">
<button style={{"background":"none"}} className="btn btn-white ms-3 my-4" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"><i className="fa fa-bars" style={{"fontSize":"30px"}} aria-hidden="true"></i>
</button> <Link to={'/signin'}><button style={{"background":"none"}} className="btn btn-white" type="button" ><i class="fa fa-phone fw-bold text-success" style={{"fontSize":"30px"}} aria-hidden="true"></i></button></Link>
<a href='#home'><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline mx-5 my-4" style={{"width":"25%", "float":"right","transform":"scale(1.9)"}}/></a>
<div className="offcanvas offcanvas-start w-50" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel"><Link><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"60%", "float":"left","transform":"scale(1.8)"}}/></Link>
</h5>
    <button type="button" className="btn-close btn-danger" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="mob offcanvas-body text-white" style={{ backgroundColor: "#E52020", textAlign: "center" }}>
  <Link to={"/signup"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Offer
    </div>
  </Link>
  <Link to={"/"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Home
    </div>
  </Link>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Websites
    </div>
  </Link>
  <Link to={"/about"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       About
    </div>
  </Link>
  <Link to="/policy" style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       Policy
    </div>
  </Link>
  <a href={"#contact"} style={{ textDecoration: "none" }}>
    <div className="a_log w-100 p-3 mt-3 text-white" style={{ fontSize: "20px" }}>
      Contact
    </div>
  </a>
</div>

</div>
</nav>
        </div>


                                  {/*templates section*/}                                

 <div class="container my-5 pt-4 text-center">
 <i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
      <h3>Choose A Website</h3>
      <hr className="hr_line"></hr>
      <div className="row g-2 mt-3">

{/* Website 1 */}
<div className="col-sm-4 text-center">
  <div className="container b_cont" style={{ width: "100%", height: "200px", overflow: "hidden" }}>
    <img src="/images/project_1.png" className="img-fluid" style={{ height: "100%", objectFit: "cover", width: "100%" }} />
  </div>
  <a href="#book" className="text-decoration-none mx-2" style={{ fontSize: '1rem' }}>
    <button data-bs-toggle="modal" data-bs-target="#modal1" className="px-4 py-2 mt-3 text-light fw-bold btn_t" style={{ backgroundColor: "#000080", border: "none", borderRadius: "30px" }}>View Website &rarr;</button>
  </a>
  <a href="/signup" className="text-decoration-none mx-2" style={{ fontSize: '1rem' }}>
    <button className="px-4 py-2 mt-3 text-light fw-bold" style={{ backgroundColor: "#E52020", border: "none", borderRadius: "30px" }}>Own This Website &rarr;</button>
  </a>
</div>

{/* Website 2 */}
<div className="col-sm-4 text-center">
  <div className="container b_cont" style={{ width: "100%", height: "200px", overflow: "hidden" }}>
    <img src="/images/project_2.png" className="img-fluid" style={{ height: "100%", objectFit: "cover", width: "100%" }} />
  </div>
  <a href="#book" className="text-decoration-none mx-2 " style={{ fontSize: '1rem' }}>
    <button data-bs-toggle="modal" data-bs-target="#modal2" className="px-4 py-2 mt-3 text-light fw-bold btn_t" style={{ backgroundColor: "#000080", border: "none", borderRadius: "30px" }}>View Website &rarr;</button>
  </a>
  <a href="/signup" className="text-decoration-none mx-2" style={{ fontSize: '1rem' }}>
    <button className="px-4 py-2 mt-3 text-light fw-bold" style={{ backgroundColor: "#E52020", border: "none", borderRadius: "30px" }}>Own This Website &rarr;</button>
  </a>
</div>

{/* Website 3 */}
<div className="col-sm-4 text-center">
  <div className="container b_cont" style={{ width: "100%", height: "200px", overflow: "hidden" }}>
    <img src="/images/project_3.png" className="img-fluid" style={{ height: "100%", objectFit: "cover", width: "100%" }} />
  </div>
  <a href="#book" className="text-decoration-none mx-2" style={{ fontSize: '1rem' }}>
    <button data-bs-toggle="modal" data-bs-target="#modal3" className="px-4 py-2 mt-3 text-light fw-bold btn_t" style={{ backgroundColor: "#000080", border: "none", borderRadius: "30px" }}>View Website &rarr;</button>
  </a>
  <a href="/signup" className="text-decoration-none mx-2" style={{ fontSize: '1rem' }}>
    <button className="px-4 py-2 mt-3 text-light fw-bold" style={{ backgroundColor: "#E52020", border: "none", borderRadius: "30px" }}>Own This Website &rarr;</button>
  </a>
</div>

{/* Modals */}
<div className="modal fade border" id="modal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-dialog-scrollable modal-xl" style={{"maxWidth":"100%","width":"100%"}}>
    <div className="modal-content">
      <div className="modal-body">
        <iframe src="https://carib-web-works-free-shipping-website.netlify.app/" style={{ border: "none", width: "100%", height: "500px" }} title="Shipping Website" />
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="modal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-dialog-scrollable modal-xl" style={{"maxWidth":"100%","width":"100%"}}>
    <div className="modal-content">
      <div className="modal-body">
        <iframe src="https://carib-web-works-free-cleaning-website.netlify.app/" style={{ border: "none", width: "100%", height: "500px" }} title="Cleaning Website" />
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="modal3" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-dialog-scrollable modal-xl" style={{"maxWidth":"100%","width":"100%"}}>
    <div className="modal-content">
      <div className="modal-body">
        <iframe src="https://carib-web-works-free-dinning-website.netlify.app/" style={{ border: "none", width: "100%", height: "500px" }} title="Dining Website" />
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

</div>

</div>

                                  {/*footer section*/} 
           <div className="body-footer text-center text-white" id="contact" style={{"backgroundColor":"#E52020"}}>
            <footer className="w-100 py-4 flex-shrink-0">
                <div className="container py-4">
                    <div className="row gy-4 gx-5">
                        <div className="col-lg-4 col-md-6">
                            <h5 className="h1 text-white">Contact Us</h5>
                            <p className="small text-white">Call: (876) 777-0826</p>
                            <p className="small text-white">Watsapp: (876) 777-0826</p>
                            <p className="small text-white">Email: caribwebworks@gmail.com </p>
                            <p className="small text-white">Address: Montego Bay, St. James</p>
                            <p><i class="fa fa-twitter-square me-3" aria-hidden="true"></i> 
                           <i class="fa fa-instagram me-3" aria-hidden="true"></i>
                            <i class="fa fa-facebook-square me-3" aria-hidden="true"></i>
                            </p>   
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled text-dark">
                                <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled">
                            <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                        <h3 className="h1 text-white">Carib Web Works</h3>
                            <img src="/images/business_logo1.png" alt="logo" className="img-fluid d-inline my-2" style={{"width":"40%","transform":"scale(1.2)"}}/>
                            <p className="small" style={{"color":"gold"}}>"Attract more customers with digital marketing"</p>
                            <i>By: Ceo & Team</i>
                        </div>
                    </div>
                </div>
                <p className="small text-dark mb-0" id="contact">&copy; Copyrights. All rights reserved. <a className="text-primary" href="/signup" target={'_blank'}>caribwebworks.com</a></p>
            </footer>
                </div>
        </>
    )
}
 
export default TempComp;